// navigation-view.js
import BasePropertyView from 'BasePropertyView.js';
import themeService     from 'ThemeService.js';
import contentTemplate from 'properties/navigation/position.ejs';
import constants from 'Constants.js';
import textConstants from 'TextConstants.js';
import util from 'util/Util.js';
import TextUtil from 'util/TextUtil.js';

import listService from 'ListService.js';
import resizeController from 'ResizeController.js';
import undoService from 'UndoService';
import eventBus         from 'EventBus.js';

class NavPositionView extends BasePropertyView {

    initialize( opts ) {
        this.options = opts || {};
        this.template = contentTemplate;
        this.tagName = 'div';
        this.id = opts.el;

        this.events = {
            'change input[type=text]' : 'updateAttributes',
            'change input[type=number]' : 'updateAttributes',
            'focus input[type=number]'   : 'getFocus',
            'keydown input[type=number]': 'validatePositiveNumeric',
            'keydown input[type=text]': 'tab',
            'click #btn-up,#btn-down':'changeZorder'
        };

        //this.listenTo(this.model, 'change', this.render);
        this.listenTo(eventBus, constants.EV_NAV_POSITION_PROPERTY_CHANGED, this.render); 
        return this;
    }

    tab(ev){
        TextUtil.validatePositiveNumeric(ev);
        const propName = ev.currentTarget.name.trim();

        if (ev.keyCode === 13 || ev.keyCode === 9) {
            $('input[name="'+propName+'"]').trigger('change');
        }
    }


    changeZorder(){
        $('#pos_zorder').trigger('change');
    }

    validatePositiveNumeric(ev){
     TextUtil.validatePositiveNumeric(ev);
    }

    updateAttributes(ev) {
        const propName = ev.currentTarget.name;
        let propVal = ev.currentTarget.value;
        let oldVal = this.model.get(propName);

        let applyChanges = (propName, propValue) => {
            let propVal = propValue;
            //PF-2063 - Picture object properties is allowing to resize object outside the form's page layout. Same fix applies for all other components.
            if (propName === 'width') {
                propVal = resizeController.getValidWidth(this.model, parseInt(propVal));            
            } else if (propName === 'height') {
                propVal = resizeController.getValidHeight(this.model, parseInt(propVal));            
            } else if (propName === 'left') {
                propVal = parseInt(propVal);
                let leftPos = parseInt(util.extractNum(propVal));
                let formWidth = parseInt(listService.currentForm.model.get('formWidth'));
                //Check if the elemnt is inside of a group to set group's edge
                let grpId = listService.getGroupObject(this.model.get('id'));
                    if( grpId !== '' ){
                        let grp = listService.getObject(grpId);
                        formWidth =  parseInt(util.extractNum(grp.model.get('width')));
                    }

                    let width = parseInt(this.model.get('width'));
                    let remainingSpace = parseInt(formWidth - width);
                    if (remainingSpace >= 0 && leftPos > remainingSpace) {
                        propVal = remainingSpace;
                    }
                } else if (propName === 'top') {
                    propVal = parseInt(propVal);
                    let topPos = parseInt(util.extractNum(propVal));
                    let formHeight = parseInt(listService.currentForm.model.get('formHeight'));
                    //Check if the elemnt is inside of a group to set group's edge
                    let grpId = listService.getGroupObject(this.model.get('id'));
                    if( grpId !== '' ){
                        let grp = listService.getObject(grpId);
                        formHeight =  parseInt(util.extractNum(grp.model.get('height')));
                        //We set the limit of the top to the min title's height only when title is shown 
                        if(util.isTrue(grp.model.get('hasTitle')) && propVal < Number(grp.model.get('titleHeight')) ){
                            propVal = Number(grp.model.get('titleHeight'));
                        }
                    }

                    let height = parseInt(this.model.get('height'));
                    let remainingSpace = parseInt(formHeight - height);
                    if (remainingSpace >= 0 && topPos > remainingSpace) {
                        propVal = remainingSpace;
                    }
            } else if( propName === 'zOrder') {
                if (isNaN(propVal)) {
                    propVal = this.model.get('zOrder');
                }
            }

            if (this.model.get(propName) === propVal) {
                if(util.isGroupContainer(this.model.get('factoryKey'))){
                    this.render();
                    eventBus.trigger('GroupPropertyChange');
                }
                else {
                    this.model.trigger('change')
                } //Force trigger change event when attribute's new value isn't changed
            }else{
                if(util.isGroupContainer(this.model.get('factoryKey'))){
                    util.updatePropertyRenderAndSendEvent(propName,propVal,this.model,this.render.bind(this),'GroupPropertyChange')
                }
                else {
                    this.model.set(propName,propVal)
                }
            }


            //Set the value of the input in case the calculated value is different than the one that was typed
            const input = $("input[name='" + propName + "'] ");
            input.val(propVal);
        };
        
        if(!TextUtil.isDecimalOrNumeric(propVal)){
                if (propName === 'width' || propName === 'height' || propName === 'zOrder') {
                    propVal=parseFloat(oldVal);
                } else if (propName === 'top' || propName === 'left' ) {
                    propVal=0;
                }
        }

        if (!oldVal || oldVal.toString() !== propVal.toString() ) {
            applyChanges(propName, propVal);

            // PF-3465 Undo/Redo for Position Values.
            undoService.add({
                undo: () =>{
                    if (this.model.get(propName) === oldVal){
                        if(util.isGroupContainer(this.model.get('factoryKey'))){
                            this.render();
                            eventBus.trigger('GroupPropertyChange');
                        }
                        else {
                            this.model.trigger('change')
                        }
                    }else{
                        if(util.isGroupContainer(this.model.get('factoryKey'))){
                            util.updatePropertyRenderAndSendEvent(propName,propVal,this.model,this.render.bind(this),'GroupPropertyChange')
                        }
                        else {
                            this.model.set(propName,propVal)
                        }
                        applyChanges(propName, oldVal);
                    }

                    this.render();
                },
                redo:() => {
                    if (this.model.get(propName) === propVal){
                        if(util.isGroupContainer(this.model.get('factoryKey'))){
                            this.render();
                            eventBus.trigger('GroupPropertyChange');
                        }
                        else {
                            this.model.trigger('change')
                        }
                    }else{
                        if(util.isGroupContainer(this.model.get('factoryKey'))){
                            util.updatePropertyRenderAndSendEvent(propName,propVal,this.model,this.render.bind(this),'GroupPropertyChange')
                        }
                        else {
                            this.model.set(propName,propVal)
                        }
                        applyChanges(propName, propVal);
                    }

                    this.render();
                }
            }, textConstants.UNDO_POSITION);
        }       
        TextUtil.focusNextElement(ev);
    }

    getViewValues() {
        return _.merge(this.model.toJSON(), {_height: themeService.resolve(this.model.get('height')), _width: themeService.resolve(this.model.get('width')) });
    }

    render() {
        let props = this.model.toJSON();
        props.width = util.extractNum(themeService.resolve(this.model.get('width')));
        props.height = util.extractNum(themeService.resolve(this.model.get('height')));

        // PF-2487: To avoid having '0' in the width/height properties... show '' instead
        props.width = props.width === 0 ? '' : props.width;
        props.height = props.height === 0 ? '' : props.height;
        
        this.$el.empty();
        this.$el.html(this.template(props));
        if (this.model.get('factoryKey')==='control_mask_text_input' 
            || ((this.model.className && this.model.className() === 'MultiSelectControlModel') && this.model.get('factoryKeys') && this.model.get('factoryKeys').has('control_mask_text_input')) ){
            $("[name='sizeSection']").hide();
        }
        $('.spinner .btn:first-of-type').on('click', function() {
            $('.spinner input').val( Number($('.spinner input').val()) + 1 );
        });
        $('.spinner .btn:last-of-type').on('click', function() {
            $('.spinner input').val( Number($('.spinner input').val()) - 1 );
        });
        this.delegateEvents();

        return this;
    }

}

export default NavPositionView;
